import { PlanGrid } from "pages/Plans/components/BusinessPlanTile/BusinessPlans";
import BusinessPlanCard from "pages/Plans/components/BusinessPlanTile/BusinessPlanCard";
import { useTranslation } from "react-i18next";
import { Title, Body } from "@vds/typography";
import { useSelector } from "react-redux";
import { MarginSpacerM } from "common/components/styleTag";
import { Button } from "@vds/buttons";
import { Carousel } from "@vds/carousels";
import { ModalTitle, ModalFooter } from "@vds/modals";
import { DivWrapper, ModalWrapper } from "./Common";
import {
  ByodContainer,
  ByodImg,
} from "pages/ShoppingCart/components/CartPackage/styles";
import styled from "styled-components";
import { formatPriceString } from "utils/commonUtils";


export const Header = ({
  image,
  packageDesc,
  capacity,
  color,
  selectedPlan,
  id,
  byod,
  eyebrow,
  isStickyHeader = false,
  totalPrice = 99.9,
}) => {
  // TODO: add total price for mybiz plans
  return (
    <div style={{ display: "flex", alignItems: "center" }} id={id}>
      <div>
        {image !== null && image ? (
          <div>
            <img
              src={image}
              alt="image"
              width={isStickyHeader ? "40px" : "72px"}
              height={isStickyHeader ? "40px" : "72px"}
            />
          </div>
        ) : (
          <ByodContainer width={"auto"} height={"auto"}>
            <ByodImg />
          </ByodContainer>
        )}
        <div style={{ marginLeft: "10px" }}>
          <Body size="large" bold={false}>
            {eyebrow}
          </Body>
          <Body size="large" bold={true}>
            {packageDesc}
          </Body>
          <Body size="large">
            {byod ? "Your own device" : <></>}
            {capacity && capacity}
            {capacity && color && ", "}
            {color && color}
          </Body>
          <Body size="large">{selectedPlan && selectedPlan}</Body>
        </div>
      </div>
      <div>
        <Title>{`Total: ${formatPriceString(
          totalPrice
        )}/line per month`}</Title>
        <Body size="small">
          {"Plus taxes and fees.\nEconomic Adjustment Charge may apply."}
        </Body>
      </div>
    </div>
  );
};

const MobileWrapper = styled.div`
  display: none;
  @media screen and (max-width: 600px) {
    display: block;
    [class^="OuterTileContainer-VDS"] {
      padding: 0px !important;
      background-color: transparent !important;
    }
    [class^="CarouselContainer-VDS"] {
      padding-left: 0px !important;
    }
    [class^="SlotContainer-VDS"] {
      width: unset;
    }
  }
`;

export const PlansCards = ({
  plans,
  displayName,
  onSelectPlan = () => {},
  selectedPlans,
  packageId,
}) => {
  const deviceCompatiblePlansInfo = useSelector(
    (state) => state.WirelessPlans.deviceCompatiblePlansInfo
  );
  const arePromosPresent = plans.some((i) => i?.promoEligible);
  const { t } = useTranslation(["plans"]);
  const plansAEM = t("plans", { ns: "plans", returnObjects: true });
  const isAutopayDiscount = displayName === "Smartphones";
  const isRecommended = (planCode) =>
    plansAEM?.aggregate_plans?.plansRecommended?.length &&
    plansAEM.aggregate_plans.plansRecommended.includes(planCode);
  const discountedPrice =
    deviceCompatiblePlansInfo?.configuration?.discount?.autoPayDiscount;

  const getPlanCard = (plan) => {
    return (
      <BusinessPlanCard
        height={"auto"}
        minHeight={690}
        key={plan.billingCode}
        planDetail={plan}
        autoPayDiscount={isAutopayDiscount && discountedPrice}
        isEnabled={true}
        onSelect={(billingCode, finalPrice) =>
          onSelectPlan(
            billingCode,
            plan.displayName,
            plan.promoEligible,
            finalPrice
          )
        }
        tierPrices={
          deviceCompatiblePlansInfo?.staticContent &&
          deviceCompatiblePlansInfo?.staticContent[plan.billingCode]
        }
        aemFeatures={
          plansAEM?.planFeatures && plansAEM.planFeatures[plan.billingCode]
        }
        isRecommended={isRecommended(plan.billingCode)}
        promoSpacing={arePromosPresent}
        fromPlansNew={true}
        selected={
          selectedPlans !== null &&
          selectedPlans &&
          selectedPlans[packageId] !== null &&
          selectedPlans[packageId] &&
          selectedPlans[packageId]["billingCode"] === plan.billingCode
            ? true
            : false
        }
      />
    );
  };

  return (
    <>
      <DivWrapper>
        <PlanGrid>{plans.map((plan) => getPlanCard(plan))}</PlanGrid>
      </DivWrapper>
      {!!plans?.length && (
        <MobileWrapper>
          <Carousel
            peek="standard"
            layout="1UP"
            gutter="24px"
            surface="light"
            paginationFill="light"
            paginationInset="12px"
            paginationDisplay=""
            aspectRatio="auto"
            data={plans}
            renderItem={(props) => getPlanCard(props)}
          />
        </MobileWrapper>
      )}
    </>
  );
};

const PlansAddMoreContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (min-width: 545px) {
    padding-top: 1rem;
  }

  @media only screen and (max-width: 545px) {
    display: block;
    flex-direction: row;
    > h2 {
      padding-top: 1rem;
      padding-bottom: 1rem;
    }
  }
`;

export const SelectDevices = ({
  addMoreDevice = () => {},
  updateAddMoreDevicePopup,
  pageHeaderSticky,
}) => {
  const { t } = useTranslation(["plans"]);
  const globalData = useSelector((state) => state.GlobalData);
  return (
    <>
      {pageHeaderSticky ? (
        <PlansAddMoreContainer>
          <Title size="large" primitive="h2" bold>
            {t("plans.aggregate_plans.heading", { ns: "plans" })}
          </Title>
          <Button
            use="secondary"
            size="small"
            className="add-devices"
            data-track="Add More Device"
            onClick={updateAddMoreDevicePopup}
          >
            Add more devices
          </Button>
        </PlansAddMoreContainer>
      ) : (
        <>
          <MarginSpacerM />
          <Title size="large" primitive="h2" bold>
            {t("plans.aggregate_plans.heading", { ns: "plans" })} 
          </Title>
          <MarginSpacerM />
          {
           !(globalData?.fromAgentLinkDealsPage && (globalData?.agentLinkFlowType === "hotspotDevices" || globalData?.agentLinkFlowType === "smartPhones")) && 
            <Button
              use="secondary"
              size="small"
              className="add-devices"
              data-track="Add More Device"
              onClick={updateAddMoreDevicePopup}
            >
               Add more devices
            </Button>
          }
          <MarginSpacerM />
        </>
      )}
    </>
  );
};

export const ApplyToAllModal = ({
  category = "",
  showModal = false,
  handleModal = () => {},
  applyPlansToDevices = () => {},
}) => {
  const { t } = useTranslation(["plans"]);
  return (
    <ModalWrapper
      opened={showModal}
      fullScreenDialog={false}
      disableAnimation={false}
      disableOutsideClick={true}
      onOpenedChange={(val) => {
        if (!val) handleModal(val);
      }}
      data-track="close"
      disableFocusLock={true}
    >
      <ModalTitle>
        {t("plans.aggregate_plans.modalTitle", {
          ns: "plans",
          category: String(category).toLowerCase(),
        })}{" "}
      </ModalTitle>
      <ModalFooter
        buttonData={{
          primary: {
            width: "100%",
            children: t("plans.aggregate_plans.applyToAll", { ns: "plans" }),
            onClick: () => applyPlansToDevices("all"),
            "data-track": t("plans.aggregate_plans.applyToAll", {
              ns: "plans",
            }),
          },
          close: {
            width: "100%",
            children: t("plans.aggregate_plans.OnlyThisDevice", {
              ns: "plans",
            }),
            onClick: () => applyPlansToDevices("current"),
            "data-track": t("plans.aggregate_plans.OnlyThisDevice", {
              ns: "plans",
            }),
          },
        }}
      />
    </ModalWrapper>
  );
};
